import { useEffect, useRef } from "react";

import { useTranslations } from "../../providers/TranslationsProvider";
import {
  ButtonsContainer,
  Container,
  Message,
  ResponseButton,
} from "./InactivePrompt.styles";

type InactivePromptProps = {
  onAnswer: (isActive: boolean) => void;
};

const InactivePrompt = ({ onAnswer }: InactivePromptProps) => {
  const translations = useTranslations();
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    buttonRef.current?.focus();
  }, []);

  return (
    <Container>
      <Message>{translations("inactive__continue_watching_question")}</Message>
      <ButtonsContainer>
        <ResponseButton
          ref={buttonRef}
          aria-label={translations("inactive__continue_watching_yes")}
          onClick={() => onAnswer(true)}
          confirm
        >
          {translations("inactive__continue_watching_yes")}
        </ResponseButton>
        <ResponseButton
          aria-label={translations("inactive__continue_watching_no")}
          onClick={() => onAnswer(false)}
        >
          {translations("inactive__continue_watching_no")}
        </ResponseButton>
      </ButtonsContainer>
    </Container>
  );
};

export { InactivePrompt };
